import _jsx from '@babel/runtime/helpers/esm/jsx';
import _styled from 'styled-components';
import { AjaxLoaderOverlay } from '@dbh/map-utils';
import { createBrowserOnlyLazyComponent } from '@dbh/react-lazy';
import Spinner from '@dbh/spinner';

var _StyledAjaxLoaderOver;// while loading the component itself. We need to reset its `position` to meet
// the overlay positioning in the loaded component.
const LoadingComponent=()=>_StyledAjaxLoaderOver||(_StyledAjaxLoaderOver=/*#__PURE__*/_jsx(_StyledAjaxLoaderOverlay,{},void 0,/*#__PURE__*/_jsx(Spinner,{visible:!0})));LoadingComponent.displayName="LoadingComponent";// At the moment we are not showing an "error UI" to the user on `error`, we
// just keep showing the loading overlay: this can change if and when there
// are specifications for such "error UI".
var index = createBrowserOnlyLazyComponent(()=>import('./component-c66319a9.js'/* webpackChunkName: "dbh.map-popup" */),LoadingComponent);var _StyledAjaxLoaderOverlay=/*#__PURE__*/_styled(AjaxLoaderOverlay).withConfig({componentId:"sc-mf37gk-0"})(["position:relative;"]);

export { index as default };
